import Cookie from 'js-cookie';
import { GlobalState } from '../states/global-state';
import { loadSettlement, load } from '../controllers/KycController';
import type {
  KycLoadDataType,
  SettlementLoadDataType,
  CompletenesResponseDataType,
  AccountLoadDataType,
} from 'src/types/types';
import { getProfile } from '../controllers/UserApiControler';

export default class Store {
  storage: any;
  propInCookie: string[];
  defaultToken: string;

  constructor() {
    this.storage = typeof window !== 'undefined' ? window.sessionStorage : {};
    this.propInCookie = ['token', 'x-csrf', 'x-token', 'x-reg-token'];
    this.defaultToken = 'userNotLogin';
  }
  clear(key?) {
    if (key) {
      if (key != 'x-csrf') {
        Cookie.remove(key);
        sessionStorage.removeItem(key);
        localStorage.removeItem(key);
      }
    } else {
      const csrf = this.get('x-csrf');
      this.propInCookie.forEach(key => {
        // console.log(16, key);
        Cookie.remove(key);
      });

      sessionStorage.clear();
      localStorage.clear();
      this.put('x-csrf', csrf);
    }
  }
  put(key, value) {
    // console.log(key, value);
    if (this.propInCookie.includes(key)) {
      Cookie.set(key, value, {
        secure: true,
        sameSite: 'lax',
        httpOnly: false,
      });
    } else {
      this.storage.setItem(key, JSON.stringify(value));
    }
  }
  get(key) {
    let data = '';
    if (this.propInCookie.includes(key)) {
      data = Cookie.get(key, {
        secure: true,
        sameSite: 'lax',
        httpOnly: false,
      });
    } else {
      data = JSON.parse(this.storage.getItem(key));
    }

    if (key == 'token' && !data) {
      data = this.defaultToken;
    }

    // console.log(64, key, data);

    return data;
  }
  isLoggedIn() {
    return (
      this.get('token') != this.defaultToken &&
      (this.get('x-token') != undefined || this.get('x-reg-token')) &&
      this.get('x-csrf') != undefined
    );
  }
  activeEpisode(value?) {
    if (value) {
      this.put('activeEpisode', value);
      return value;
    }
    return this.get('activeEpisode');
  }
  setFormData(obj) {
    this.getFormData(null, items => {
      const merge = { ...items, ...obj };

      this.put('form-data', merge);
    });
  }
  getFormData(key, callback) {
    const name = 'form-data';
    let store: any = this.get(name);

    const kycLoad = GlobalState.kycLoad.value;
    const settlementLoad = GlobalState.settlementLoad.value;

    if (!store) {
      store = {};
    }

    store = { ...kycLoad, ...settlementLoad, ...store };

    callback(Object.keys(store).length ? store : null);
  }
  async getProfileData() {
    try {
      const update = this.get('form-data') || {};

      const profile = (await getProfile()) || ({} as any);

      if (!profile) {
        return null;
      }

      /**
       * merge the data saved locally to the
       * data from the api
       */

      Object.keys(profile).forEach(category => {
        const props = profile[category];
        Object.keys(props).forEach(prop => {
          if (update[prop]) {
            profile[category][prop] = update[prop];
          }
        });
      });

      GlobalState.accountLoad.value = profile.account as AccountLoadDataType;
      GlobalState.kycLoad.value = profile.kyc as KycLoadDataType;
      GlobalState.settlementLoad.value =
        profile.settlement as SettlementLoadDataType;

      GlobalState.completeness.value =
        profile.completeness as CompletenesResponseDataType;

      return {
        ...GlobalState.kycLoad.value,
        ...GlobalState.settlementLoad.value,
        ...GlobalState.accountLoad.value,
      };
    } catch (err) {
      console.log(err);
    }
  }
  async getCompleteness() {
    try {
      const profile = (await getProfile()) || ({} as any);

      if (!profile) {
        return null;
      }

      GlobalState.completeness.value =
        profile.completeness as CompletenesResponseDataType;

      return GlobalState.completeness.value || {};
    } catch (err) {
      console.log(err);
    }
  }
}
